// extracted by mini-css-extract-plugin
export var button = "EntriesFooter-module--button--91751";
export var footer = "EntriesFooter-module--footer--1b964";